import { useState } from 'react';
import clsx from 'clsx';
import { Modal } from 'react-bootstrap-v5';

const PASSOS = [
    {
        icone: 'fa-cog',
        titulo: '1. Preparar',
        texto: 'Cadastre as contas bancárias da empresa e configure o Setup: quando o extrato disser TARIFA, para qual conta contábil vai. Costuma ser feito uma vez e vale para os próximos períodos.',
    },
    {
        icone: 'fa-file-upload',
        titulo: '2. Arquivos',
        texto: 'Envie os extratos e clique em Iniciar processamento. O saldo inicial precisa bater com o saldo final do extrato anterior; se não bater, o extrato fica retido. Comprovantes, retornos, RFB, NFS-e e folha são opcionais e ajudam a explicar mais linhas.',
    },
    {
        icone: 'fa-file-signature',
        titulo: '3. Minutas',
        texto: 'Minuta é o lançamento que o módulo propõe para cada linha do extrato sem contabilização. As Pendentes dizem o que falta; as Geradas só precisam da sua conferência. Nada entra no razão nesta etapa.',
    },
    {
        icone: 'fa-file-export',
        titulo: '4. Fechar e exportar',
        texto: 'Com as minutas decididas, feche a conta e exporte o TXT para o Domínio. Quando o razão for reimportado, as minutas viram Contabilizadas. Reimportar antes de exportar desfaz as aprovações.',
    },
];

// O guia não depende da tela por trás, então continua certo quando a tela muda.
export default function GuiaModulo({ onFechar }: { onFechar: () => void }) {
    const [passo, setPasso] = useState(0);
    const atual = PASSOS[passo];
    const ultimo = passo === PASSOS.length - 1;

    return (
        <Modal show onHide={onFechar} centered>
            <Modal.Header closeButton>
                <Modal.Title>Como funciona o Módulo Bancário</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='text-center py-3' style={{ minHeight: 220 }}>
                    <i className={clsx('fas fs-2x text-primary mb-4', atual.icone)}></i>
                    <h3 className='fw-bold mb-3'>{atual.titulo}</h3>
                    <div className='text-gray-700 fs-6'>{atual.texto}</div>
                </div>
                <div className='d-flex justify-content-center gap-2' aria-label={`Passo ${passo + 1} de ${PASSOS.length}`}>
                    {PASSOS.map((p, i) => (
                        <button key={p.titulo} type='button' title={p.titulo} aria-label={p.titulo} onClick={() => setPasso(i)}
                            className={clsx('btn btn-flush rounded-circle', i === passo ? 'bg-primary' : 'bg-secondary')} style={{ width: 10, height: 10 }}></button>
                    ))}
                </div>
            </Modal.Body>
            <Modal.Footer className='justify-content-between'>
                <button className='btn btn-light' onClick={onFechar}>Fechar</button>
                <div className='d-flex gap-2'>
                    {passo > 0 && <button className='btn btn-light' onClick={() => setPasso(passo - 1)}>Voltar</button>}
                    {ultimo
                        ? <button className='btn btn-primary' onClick={onFechar}>Começar</button>
                        : <button className='btn btn-primary' onClick={() => setPasso(passo + 1)}>Próximo</button>}
                </div>
            </Modal.Footer>
        </Modal>
    );
}
